let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aUV6Y")).then(() => parcelRequire('2U8sz'));